import React from 'react'
import { MANTHLY_FINANCE_DETAIL } from '../urls'
import { usePutRequest } from '../hooks/request'
import ServerError from './componentsFinance/common/ServerError'
import ManthlyFinanceForm from './ManthlyFinanceForm'

export default function ManthlyFinanceUpdate({ onCancel, onUpdate, finance }) {
    const url = MANTHLY_FINANCE_DETAIL.replace('{id}', finance.id)
    const financeUpdate = usePutRequest({ url })
    async function onSubmit(data) {
        const { success } = await financeUpdate.request({ data })

        if (success) {
            onUpdate()
        }
    }

    return (
        <div>
            <b>Изменить данные о клиенты</b><br /><br />
            <ServerError error={financeUpdate.error} />
            <ManthlyFinanceForm
                initialValues={finance}
                onSubmit={onSubmit}
                onCancel={onCancel}
                loading={financeUpdate.loading} />
        </div>
    )
}
